// AnimatedLinePlaceholder.js
import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  // Tooltip, // Not needed for a placeholder
  // Legend,  // Not needed for a placeholder
} from 'chart.js';

// Register only the necessary components for a simple line chart
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler
);

const AnimatedLinePlaceholder = () => {
  const data = {
    // Use empty labels for a cleaner look or few generic labels
    labels: ['', '', '', '', '', '', '', '', '', '', '', ''], 
    datasets: [
      {
        label: 'Visualizing...', // This won't be shown if legend is false
        data: [30, 35, 50, 60, 55, 70, 65, 75, 90, 80, 85, 100], // Sample data for a gentle upward trend
        fill: {
          target: 'origin',
          above: 'rgba(75, 192, 192, 0.1)', // A light, subtle fill color
        },
        borderColor: 'rgb(75, 192, 192)', // A pleasant teal color
        tension: 0.4, // Makes the line curvy and smooth
        pointRadius: 0, // No visible points on the line
        borderWidth: 2.5, // Slightly thicker line
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false, // Important for fitting into a sized container
    animation: {
      duration: 1800, // Duration of the animation in milliseconds
      easing: 'easeInOutQuart', // Smooth easing function for the animation
      // Animate the line drawing from left to right or a similar effect
      // This is often the default behavior for line charts.
    },
    scales: {
      x: {
        display: false, // Hide x-axis, grid lines, and labels
      },
      y: {
        display: false, // Hide y-axis, grid lines, and labels
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        display: false, // No need for a legend in a placeholder
      },
      tooltip: {
        enabled: false, // No tooltips needed for a placeholder
      },
    },
    elements: {
      line: {
        // borderWidth: 2, // Already set in dataset
      },
    },
    layout: {
      padding: { // Add a little padding so the line doesn't touch the edges
        left: 5,
        right: 5,
        top: 10,
        bottom: 5
      }
    }
  };

  return <Line options={options} data={data} />;
};

export default AnimatedLinePlaceholder;